/**
 * intc-sticky-atc-sync.js
 *
 * Keeps the sticky add-to-cart bar's price and selected-variant text in sync
 * with the real buy box on variant change. assets/product-info.js already
 * fetches the updated section HTML and republishes it as
 * PUB_SUB_EVENTS.variantChange ({ sectionId, html, variant }) after updating
 * its own known ids (price-<sectionId>, Sku-<sectionId>, etc.) — this bar's
 * elements aren't among those ids, so nothing else refreshes them.
 * Subscribing here avoids editing the hard-gated product-info.js.
 */
(function () {
  'use strict';

  function intcUpdateStickyAtc(sectionId, html, variant) {
    var bar = document.querySelector('.intc-sticky-atc[data-section-id="' + sectionId + '"]');
    if (!bar) return;

    var priceSource = html.getElementById('price-' + sectionId);
    var priceDestination = bar.querySelector('.intc-sticky-atc__price');
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
    }

    var variantEl = bar.querySelector('.intc-sticky-atc__variant');
    if (!variantEl) return;

    if (variant && variant.title && variant.title !== 'Default Title') {
      variantEl.textContent = variant.title;
      variantEl.hidden = false;
    } else {
      variantEl.hidden = true;
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event.data;
      if (!data || !data.html) return;
      intcUpdateStickyAtc(data.sectionId, data.html, data.variant);
    });
  }
})();
